import { Component } from "@angular/core";
import { ColDef } from 'ag-grid-community';

import { CaseContextRecordPanelBase } from "@app/case-context/components/case-context-record-panel-base.directive";
import { InmateOffenseRecord } from "@app/case-context/models/inmate-offense-record.model";
import { PHMS_CASE_CONTEXT_TERMINOLOGY } from "@app/phms/phms-case-context.terminology";
import { CaseContextRecordGridComponent } from '../case-context-record-grid/case-context-record-grid.component';
import { labelValueFormatter, recordCodeValueGetter, recordDateValueFormatter, recordLabelValueGetter } from '../case-context-record-grid/case-context-record-grid-columns';
import { TerminologyIdentityDirective } from "@app/shared/terminology/terminology-identity.directive";
import { createTerminologyUsageSignals } from "@app/shared/terminology/terminology-usage-signals";

/**
 * Criminal-history panel: accepts only rows tagged "criminal_history".
 */
@Component({
  selector: "phms-case-context-criminal-history-panel",
  standalone: true,
  imports: [CaseContextRecordGridComponent, TerminologyIdentityDirective],
  templateUrl: "./case-context-criminal-history-panel.component.html",
})
export class CaseContextCriminalHistoryPanelComponent extends CaseContextRecordPanelBase {
  readonly sectionUsage = PHMS_CASE_CONTEXT_TERMINOLOGY.criminalHistory;
  readonly sectionText = createTerminologyUsageSignals(this.sectionUsage);
  readonly columnDefs: ColDef<InmateOffenseRecord>[] = [
    {field: 'eventDate', headerName: 'Date', width: 100, minWidth: 95, sort: 'desc', valueFormatter: recordDateValueFormatter},
    {field: 'recordCode', headerName: 'Code', width: 130, minWidth: 110, valueGetter: recordCodeValueGetter},
    {field: 'recordLabel', headerName: 'Record', flex: 1, minWidth: 200, valueGetter: recordLabelValueGetter},
    {field: 'dispositionCode', headerName: 'Disposition', width: 130, valueFormatter: labelValueFormatter},
    {field: 'recordStatusCode', headerName: 'Status', width: 100, valueFormatter: labelValueFormatter},
  ];

  protected accepts(record: InmateOffenseRecord): boolean {
    return record.recordCategoryCode === "criminal_history";
  }
}
